import styled from 'styled-components';

// Styled components for User Management page
export const ForbiddenWrapper = styled.div`
  text-align: center;
  padding: 50px;
`;

